import type { PermissionKey, Session } from "./types";

/**
 * A tela só consome a decisão que veio da API. Papel não é reavaliado aqui:
 * isso criaria uma segunda política e ignoraria concessões e revogações.
 */
export function hasPermission(
  session: Session | null | undefined,
  permission: PermissionKey,
): boolean {
  return session?.permissions.includes(permission) ?? false;
}
